import { render, staticRenderFns } from "./TheDiagnostic.vue?vue&type=template&id=0a86e694&scoped=true&"
import script from "./TheDiagnostic.vue?vue&type=script&lang=js&"
export * from "./TheDiagnostic.vue?vue&type=script&lang=js&"
import style0 from "./TheDiagnostic.vue?vue&type=style&index=0&id=0a86e694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86e694",
  null
  
)

export default component.exports